import { DEFAULT_CUSTOM_QUESTIONS } from "@scoach/types";
import { Button } from "@scoach/ui";
import { Close } from "@scoach/ui/icons";

/**
 * Reusable editor for the per-user custom-summary question list. Controlled —
 * the parent owns the array and persists it (to UserSettings.customQuestions).
 * Used by the Settings "Custom summary" tab and the summary page's custom card.
 */
export function CustomQuestionsEditor({
  questions,
  onChange,
}: {
  questions: string[];
  onChange: (next: string[]) => void;
}) {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {questions.map((q, i) => (
          <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input
              value={q}
              placeholder="e.g. How much money have they raised?"
              onChange={(e) => onChange(questions.map((x, j) => (j === i ? e.target.value : x)))}
              style={{ flex: 1 }}
            />
            <button
              type="button"
              className="icon-btn xs danger"
              title="Remove question"
              onClick={() => onChange(questions.filter((_, j) => j !== i))}
            >
              <Close size={14} />
            </button>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 12, marginTop: 12, alignItems: "center" }}>
        <Button variant="ghost" onClick={() => onChange([...questions, ""])}>
          + Add question
        </Button>
        <button
          type="button"
          className="ghost-btn"
          onClick={() => onChange([...DEFAULT_CUSTOM_QUESTIONS])}
        >
          Reset to defaults
        </button>
      </div>
    </>
  );
}
